'use client';
import { useCallback } from 'react';
import { FieldPath, FieldValues, useController } from 'react-hook-form';

export const useSetFieldTouched = <SchemaShape extends FieldValues>(name: FieldPath<SchemaShape>) => {
    const controller = useController({ name });
    return useCallback(() => controller.field.onBlur(), [controller.field]);
};
